import { AlphaWIcon } from './AlphaWIcon';

/**
 * author: GreenTurtwig
 * id DFACCE73-8433-472E-AAB6-6471BBFDC82C
 * name alpha-w
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-w.svg
 * tags
 * - Alpha / Numeric 
 */
export const LetterWIcon = AlphaWIcon;
export default LetterWIcon